import React, { FC, useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import Grid from 'components/UI/Grid';
import api from 'Api/ApiMethods';
import { NotificationType } from 'models/restTypes';
import NotificationTypesTable from './NotificationTypesTable';

const Container = styled(Grid)`
  height: 100%;
  width: 100%;
  justify-content: flex-start;
`;

const NotificationTypes: FC = observer(() => {
  const [data, setData] = useState<NotificationType[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    setLoading(true);
    api
      .getNotificationTypes()
      .then((response) => {
        setData(response);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <Container>
      <NotificationTypesTable notificationTypes={data} isLoading={loading} />
    </Container>
  );
});

export default NotificationTypes;
